import { render, staticRenderFns } from "./SocialAuthButtons.vue?vue&type=template&id=5b9b0c10"
import script from "./SocialAuthButtons.vue?vue&type=script&lang=js"
export * from "./SocialAuthButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports